import { render, staticRenderFns } from "./Supporters.vue?vue&type=template&id=1d61ba5b&"
import script from "./Supporters.vue?vue&type=script&lang=js&"
export * from "./Supporters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports